export const SPACES_INVOICES_BUCKET = 'agora-invoices';
export const SPACES_VIDEO_RECORDINGS_BUCKET = 'video-recordings';
export const SPACES_AGORA_ASSETS_BUCKET = 'agora-assets';
export const SPACES_USER_GENERATED_CONTENT_BUCKET = 'user-generated-content';
export const SPACES_MENTOR_CVS_BUCKET = 'mentor-cvs';
export const SPACES_PERSONAL_DATA_EXPORTS_BUCKET = SPACES_MENTOR_CVS_BUCKET;
export const SPACES_PERSONAL_DATA_EXPORTS_PREFIX = 'personal-data-exports';
